<app-mainavbar [idRol]="6"></app-mainavbar>

<div class="flex flex-wrap justify-content-evenly">

  <p-card [header]="'Enfermeras'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
    <p class="m-0" (click)="recargarInformacion()">
      <a [routerLink]="['./enfermeras']"> {{totalEnfermeras }} </a>
    </p>
  </p-card>

  <p-card [header]="'Casos Clinicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
    <p class="m-0" (click)="recargarInformacion()">
      <a [routerLink]="['./casosclinicos']"> {{totalCasosClinicos}} </a>
    </p>
  </p-card>

  <p-card [header]="'Pendientes por asignar'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
    <p class="m-0" (click)="recargarInformacion()">
      <a [routerLink]="['./pendientes']">{{pendientesporasignar}}</a>
    </p>
  </p-card>


</div>

<router-outlet></router-outlet>